<template>
    <div>
        <div class="c-m-reactive-form-selector">
            <div
                class="c-m-reactive-form-selector__inner c-m-reactive-form-selector__inner--drilldown"
                v-if="categories && !selectedCategory"
            >
                <drilldown
                    class="c-a-drilldown--vertically-compact"
                    key="rf-select"
                    :items="categories"
                    :label="selectTitle"
                    :placeholder="'Beskriv eller välj kategori'"
                    @input="setCategory"
                ></drilldown>
            </div>

            <div class="c-m-reactive-form-selector" v-else>
                <div
                    class="c-m-reactive-form-selector__inner c-m-reactive-form-selector__inner--cta"
                >
                    <label class="c-m-reactive-form-selector__label">{{
                        selectTitle
                    }}</label>
                    <atom-button
                        :label="'Gå vidare'"
                        @buttonClicked="setCurrentCategory"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_CATEGORIES } from "../../../store/store-models/filters-model";

import AtomButton from "../atoms/AtomButton.vue";
import Drilldown from "../atoms/form/AtomDrilldownCategories.vue";

export default {
    props: ["selectedRegion", "selectedCategory"],
    components: {
        Drilldown,
        AtomButton
    },
    computed: {
        ...mapGetters({
            categories: GET_CATEGORIES
        }),
        selectTitle: function() {
            const regionText = this.selectedRegion
                ? `kvalitetssäkrade hantverkare i ${this.selectedRegion.Name}`
                : "kvalitetssäkrade hantverkare";

            return `Skapa förfrågan som går ut till ${regionText}`;
        },
        buttonTitle: function() {
            const regionText = this.selectedRegion
                ? ` i ${this.selectedRegion.Name}`
                : "";
            const categoryText = this.selectedCategory
                ? `gällande ${this.selectedCategory.Name}`
                : "";

            return `Skapa en förfrågan ${categoryText} ${regionText} och få upp till 6 svar.`;
        }
    },
    methods: {
        setCategory(value) {
            this.$router.push({
                name: "Skapa förfrågan",
                params: {
                    id: value.Id
                }
            });
        },
        setCurrentCategory() {
            this.setCategory(this.selectedCategory);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeReactiveRequestFormSelector.vue